export default __webpack_public_path__ + "static/media/tattered_curtains.68189a19.png";